export class KeydownListener {
	constructor() {
		this.keydownListener = null;
	}

	keydownHandler(e, callback) {
		const tag = e.target.tagName.toLowerCase();

		if ((e.key === 'Enter' && tag !== 'textarea') || ((e.metaKey || e.ctrlKey) && e.key === 'Enter')) {
			e.preventDefault();

			callback();
		}
	}

	toggle(callback = null) {
		if (this.keydownListener) {
			document.removeEventListener('keydown', this.keydownListener);

			this.keydownListener = null;
		}

		if (typeof callback === 'function') {
			this.keydownListener = (e) => this.keydownHandler(e, callback);

			document.addEventListener('keydown', this.keydownListener);
		}
	}
}
